import { createSlice } from '@reduxjs/toolkit';

const initialState = { checkout: null, status: 'idle', error: null };

const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    checkoutRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    checkoutSuccess(state, action) {
      state.status = 'succeeded';
      state.checkout = action.payload;
    },
    checkoutFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    checkoutReset(state) {
      state.status = 'idle';
      state.error = null;
      state.checkout = null;
    },
  },
});

export const checkoutAction = checkoutSlice.actions;
export default checkoutSlice;